module.exports = __webpack_public_path__ + "img/ironSource-app.e4c4710e.svg";